import i18next from 'i18next';
import { useTranslation as usei18nextTranslation } from 'react-i18next';

const NAMESPACE = 'AUTH';

i18next.addResources('es', NAMESPACE, {
  LOG_IN_MICROSOFT: 'Iniciar con Microsoft',
  LOG_IN_OKTA: 'Iniciar con Okta',
  UPDATE_PASSWORD: 'Actualizar contraseña',
  UPDATE_PASSWORD_TITLE: 'Tu contraseña fue restablecida y debes actualizarla',
  REPEAT_PASSWORD_LABEL: 'Repetir contraseña',
  PASSWORD_LABEL: 'Contraseña',
  REPEAT_PASSWORD_ERROR: 'Las contraseñas no coinciden',
  SELECT_A_COMMUNITY: 'Seleccionar una comunidad',
  SUCCESS_UPDATE_PASSWORD: 'Contraseña establecida con éxito.',
  WARNING_AZURE_LOGIN_INTERACTION_IN_PROGRESS: 'Ya se tiene en progreso un inicio de sesión con Microsoft',
  ERROR_UPDATE_PASSWORD: 'Error: no se pudo actualizar la contraseña',
  ERROR_AZURE_LOGIN: 'Error: no se pudo iniciar con Microsoft',
  ERROR_AZURE_GET_INSTANCES: 'Error: tu cuenta de Microsoft no tiene ninguna comunidad asociada',
  ERROR_OKTA_LOGIN: 'Error: no se pudo iniciar con Okta',
  ERROR_OKTA_GET_INSTANCES: 'Error: tu cuenta de Okta no tiene ninguna comunidad asociada',
  ERROR_GOOGLE_LOGIN: 'Error: no se pudo iniciar con Google',
  ERROR_GOOGLE_GET_INSTANCES: 'Error: tu cuenta de Google no tiene ninguna comunidad asociada',
  SHOW_HIDE_BUTTON: 'mostrar u ocultar la contraseña',
});

i18next.addResources('en', NAMESPACE, {
  LOG_IN_MICROSOFT: 'Join with Microsoft',
  LOG_IN_OKTA: 'Join with Okta',
  UPDATE_PASSWORD: 'Update password',
  UPDATE_PASSWORD_TITLE: 'Your password has been reset and you must set a new one',
  REPEAT_PASSWORD_LABEL: 'Repeat password',
  PASSWORD_LABEL: 'Password',
  REPEAT_PASSWORD_ERROR: 'Passwords don\'t match',
  SELECT_A_COMMUNITY: 'Which community would you like to log in to?',
  SUCCESS_UPDATE_PASSWORD: 'Password set successfully.',
  WARNING_AZURE_LOGIN_INTERACTION_IN_PROGRESS: 'A sign-in with Microsoft is already in progress',
  ERROR_UPDATE_PASSWORD: 'Error: password couldn\'t be updated',
  ERROR_AZURE_LOGIN: 'Error: it was not possible to login with Microsoft',
  ERROR_AZURE_GET_INSTANCES: 'Error: your Microsoft account doesn\'t have any community associated',
  ERROR_OKTA_LOGIN: 'Error: it was not possible to login with Okta',
  ERROR_OKTA_GET_INSTANCES: 'Error: your Okta account doesn\'t have any community associated',
  ERROR_GOOGLE_LOGIN: 'Error: it was not possible to login with Google',
  ERROR_GOOGLE_GET_INSTANCES: 'Error: your Google account doesn\'t have any community associated',
  SHOW_HIDE_BUTTON: 'show or hide password',
});

i18next.addResources('pt', NAMESPACE, {
  LOG_IN_MICROSOFT: 'Fazer login com a Microsoft',
  LOG_IN_OKTA: 'Fazer login com a Okta',
  UPDATE_PASSWORD: 'Redefinir senha',
  UPDATE_PASSWORD_TITLE: 'Sua senha foi restaurada. Você deve atualizá-la',
  REPEAT_PASSWORD_LABEL: 'Confirmar senha',
  PASSWORD_LABEL: 'Senha',
  REPEAT_PASSWORD_ERROR: 'As senhas não correspondem',
  SELECT_A_COMMUNITY: 'Em que comunidade você gostaria de fazer o login?',
  SUCCESS_UPDATE_PASSWORD: 'Senha definida com sucesso.',
  WARNING_AZURE_LOGIN_INTERACTION_IN_PROGRESS: 'Uma entrada com a Microsoft já está em andamento',
  ERROR_UPDATE_PASSWORD: 'Erro: não foi possível definir a senha',
  ERROR_AZURE_LOGIN: 'Erro: não foi possível fazer login com a Microsoft',
  ERROR_AZURE_GET_INSTANCES: 'Sua conta da Microsoft não possui uma comunidade associada',
  ERROR_OKTA_LOGIN: 'Erro: não foi possível fazer login com a Okta',
  ERROR_OKTA_GET_INSTANCES: 'Sua conta da Okta não possui uma comunidade associada',
  ERROR_GOOGLE_LOGIN: 'Erro: não foi possível fazer login com a Google',
  ERROR_GOOGLE_GET_INSTANCES: 'Sua conta da Google não possui uma comunidade associada',
  SHOW_HIDE_BUTTON: 'mostrar ou ocultar a senha',
});

export const useTranslation = () => usei18nextTranslation([NAMESPACE, 'GENERAL']);
